//================================================================
//  Page: Assign/Novate Agreement Form
//================================================================

//  Purpose: Read-only digital commercial request form for assign/novate agreement

//================================================================

//Libraries
import React from 'react';

//Contexts

//Components

//Functions

//Images
import FileIcon from '../Images/Icon_File_Black.svg';
import InfoRequired from '../Images/Icon_InfoRequired_Blue.svg';

//CSS

export default function AssignNovateAgreement({
    task
}) {

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <div className='h-full flex flex-col gap-2'>

            {/* ============================ */}
            {/*          Questions           */}
            {/* ============================ */}

            <form className='flex flex-col gap-3'>

                {/* ------------- REQUEST INFORMATION ------------- */}

                <h5 className='text-[18px] text-teal-600 mt-2 mb-1'>Request Information</h5>

                {/* =========================================================== */}
                {/*  1. Request Type                                            */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 1. Request Type <span className='text-[#C4314B]'>*</span></label>
                    <select className='Input-Field-Select' disabled>
                        <option>{task?.requesttype}</option>
                    </select>                        
                </div>

                {/* =========================================================== */}
                {/*  2. Application Name                                        */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 2. Application Name </label>
                    <input
                        disabled
                        className='Input-Field-Text'
                        style={{ width: '300px' }}
                        value={task?.applicationname === '' ? '-' : task?.applicationname}
                        type='text'
                    ></input>
                </div>

                {/* =========================================================== */}
                {/*  3. Short Description                                       */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 3. Short Description <span className='text-[#C4314B]'>*</span></label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        value={task?.shortdescription}
                        type='text'
                    ></textarea>
                </div>

                {/* =========================================================== */}
                {/*  4. What is the problem you are trying to solve?            */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 4. What is the problem you are trying to solve? <span className='text-[#C4314B]'>*</span></label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        value={task?.problemtosolve}
                        type='text'
                    ></textarea>
                </div>

                {/* =========================================================== */}
                {/*  5. What is the outcome you are looking for?                */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 5. What is the outcome you are looking for? <span className='text-[#C4314B]'>*</span></label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        value={task?.expectedoutcome}
                        type='text'
                    ></textarea>
                </div>

                {/* =========================================================== */}
                {/*  6. What would be the impact if this didn't go ahead?       */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 6. What would be the impact if this didn't go ahead? <span className='text-[#C4314B]'>*</span></label>
                    <textarea
                        disabled
                        className='Input-Field-TextArea'
                        value={task?.expectedimpact}
                        type='text'
                    ></textarea>
                </div>

                {/* =========================================================== */}
                {/*  7. Requester Name                                          */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 7. Requester Name <span className='text-[#C4314B]'>*</span></label>
                    <input
                        className='Input-Field-Text md:w-[450px]'
                        type='text'
                        value={task?.requestername}
                        disabled
                    ></input>
                </div>

                {/* =========================================================== */}
                {/*  8. Region                                                  */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 8. Region <span className='text-[#C4314B]'>*</span></label>
                    <select className='Input-Field-Select' disabled>
                        <option>{task?.region}</option>
                    </select>                        
                </div>

                {/* =========================================================== */}
                {/*  9. Sponsor Name                                            */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 9. Sponsor Name <span className='text-[#C4314B]'>*</span></label>
                    <select className='Input-Field-Select' disabled>
                        <option>{task?.sponsorname.email}</option>
                    </select>
                </div>

                {/* =========================================================== */}
                {/*  10. Supporting Documents                                   */}
                {/* =========================================================== */}

                <div className='FormComponent-Row'>
                    <label className='font-medium'> 10. Supporting Documents </label>
                    {
                        task?.supportingdocs.length === 0 ?
                            (
                                <div>
                                    No documents found.
                                </div>
                            )
                            :
                            (
                                <table className='table-auto w-full border-separate border-spacing-0 border-1 border-solid border-[#D8D8D8] rounded-[10px]'>
                                    <thead>
                                        <tr>
                                            <th className='font-normal px-3 py-2'>Uploaded Documents</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            task?.supportingdocs.map((file, index) => (
                                                <tr key={index}>
                                                    <td className='flex flex-row gap-2 px-3 py-2 text-[#0972D3] underline border-t border-t-[#D8D8D8]'>
                                                        <img src={FileIcon} alt='file'></img>
                                                        <a href={file?.fileUrl} target='_blank' rel='noreferrer'>
                                                            {file?.fileName}
                                                        </a>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            )
                    }
                </div>

                {/* ------------- CONTRACT INFORMATION ------------- */}

                <h5 className='text-[18px] text-teal-600 mt-4 mb-2'>Contract Information</h5>

                {/* =========================================================== */}
                {/*  11. Detailed Request / Scope Description                   */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 11. Detailed Request / Scope Description <span className='text-[#C4314B]'>*</span></label>
                    <textarea
                        className='Input-Field-TextArea'
                        value={task?.commercialscope}
                        disabled
                    ></textarea>
                </div>

                {/* =========================================================== */}
                {/*  12. Urgency                                                */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 12. Urgency <span className='text-[#C4314B]'>*</span></label>
                    <select className='Input-Field-Select' style={{ width: '200px' }} disabled>
                        <option>{task?.urgency}</option>
                    </select>
                </div>

                {/* =========================================================== */}
                {/*  13. Impact                                                 */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 13. Impact <span className='text-[#C4314B]'>*</span></label>
                    <select className='Input-Field-Select' style={{ width: '200px' }} disabled>
                        <option>{task?.impact}</option>
                    </select>
                </div>

                {/* =========================================================== */}
                {/*  14. Buy/Sell Agreement                                     */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 14. Is this a Buy or Sell Agreement? <span className='text-[#C4314B]'>*</span></label>
                    <select className='Input-Field-Select' style={{ width: '200px' }} disabled>
                        <option>{task?.buysellagreement}</option>
                    </select>
                </div>

                {/* =========================================================== */}
                {/*  15. Agreement Type                                         */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 15. Agreement Type <span className='text-[#C4314B]'>*</span></label>
                    <select className='Input-Field-Select' disabled>
                        <option>{task?.agreementtype}</option>
                    </select>
                </div>

                {/* =========================================================== */}
                {/*  16. Lendlease Company                                      */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 16. Lendlease Company (Signing Entity) <span className='text-[#C4314B]'>*</span></label>
                    <select className='Input-Field-Select' disabled>
                        <option>{task?.lendleasecompany}</option>
                    </select>
                </div>

                {/* ------------- OTHER PARTY INFORMATION (VENDOR/CUSTOMER) ------------- */}

                <h5 className='text-[18px] text-teal-600 mt-4 mb-2'> Other Party Information (Vendor / Customer) </h5>

                {/* =========================================================== */}
                {/*  17. Vendor Name                                            */}
                {/* =========================================================== */}

                <div className='FormComponent-Row'>
                    <label className='font-medium'> 17. Vendor Name </label>
                    {
                        task?.newvendorname?.length === 0 ?

                            // Existing Vendor
                            <input
                                className='Input-Field-Text md:w-[450px]'
                                type='text'
                                value={task?.vendor?.vendorname}
                                disabled
                            ></input>

                            :

                            // New Vendor
                            <div className='flex flex-col justify-center bg-[#F5F5F5] px-4 py-3 rounded-md border border-[#D8D8D8]'>

                                {/* Header */}
                                <div className='flex flex-row gap-2 items-center'>
                                    <img src={InfoRequired} alt='info'></img>
                                    <label className='font-medium text-[#5E93AC]'>New Vendor Request</label>
                                </div>

                                {/* Form */}
                                <div className='grid grid-cols-2 gap-2'>

                                    {/* Column 1 */}
                                    <div className='flex flex-col gap-2 px-2 mt-0 mb-2'>

                                        {/* Vendor Name */}
                                        <div className='Task-Form-Row'>
                                            <label className='font-medium'> Vendor Name </label>
                                            <input
                                                className='Input-Field-Text'
                                                style={{ width: '100%' }}
                                                value={task?.newvendorname}
                                                type='text'
                                                disabled
                                            ></input>
                                        </div>

                                        {/* Vendor Phone */}
                                        <div className='Task-Form-Row'>
                                            <label className='font-medium'> Vendor Phone </label>
                                            <input
                                                className='Input-Field-Text'
                                                style={{ width: '100%' }}
                                                value={task?.newvendorcontactphone === '' ? '-' : task?.newvendorcontactphone}
                                                type='text'
                                                disabled
                                            ></input>
                                        </div>

                                    </div>

                                    {/* Column 2 */}
                                    <div className='flex flex-col gap-2 px-2 mt-0 mb-2'>

                                        {/* Vendor Trading As Name */}
                                        <div className='Task-Form-Row'>
                                            <label className='font-medium'> Vendor Trading As Name </label>
                                            <input
                                                className='Input-Field-Text'
                                                style={{ width: '100%' }}
                                                value={task?.newvendortradingname}
                                                type='text'
                                                disabled
                                            ></input>
                                        </div>

                                        {/* Vendor Email */}
                                        <div className='Task-Form-Row'>
                                            <label className='font-medium'> Vendor Email </label>
                                            <input
                                                className='Input-Field-Text'
                                                style={{ width: '100%' }}
                                                value={task?.newvendorcontactemail === '' ? '-' : task?.newvendorcontactemail}
                                                type='text'
                                                disabled
                                            ></input>
                                        </div>

                                    </div>

                                </div>

                            </div>
                    }
                </div>

                {/* ------------- FINANCIAL INFORMATION ------------- */}

                <h5 className='text-[18px] text-teal-600 mt-4 mb-2'> Financial Information </h5>

                {/* =========================================================== */}
                {/*  18. Budget Owner                                           */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 18. Budget Owner <span className='text-[#C4314B]'>*</span></label>
                    <input
                        className='Input-Field-Text md:w-[450px]'
                        type='text'
                        value={`${task?.budgetowner?.givenname} ${task?.budgetowner?.surname}`}
                        disabled
                    ></input>
                </div>

                {/* =========================================================== */}
                {/*  19. Finance Manager                                        */}
                {/* =========================================================== */}

                <div className='Form-Row w-full'>
                    <label className='font-medium'> 19. Finance Manager <span className='text-[#C4314B]'>*</span></label>
                    <input
                        className='Input-Field-Text md:w-[450px]'
                        type='text'
                        value={`${task?.financemanager?.givenname} ${task?.financemanager?.surname}`}
                        disabled
                    ></input>
                </div>

            </form>

        </div>
    )
    
}